import { render, staticRenderFns } from "./page-tabs.vue?vue&type=template&id=0956b106&scoped=true"
import script from "./page-tabs.vue?vue&type=script&lang=js"
export * from "./page-tabs.vue?vue&type=script&lang=js"
import style0 from "./page-tabs.vue?vue&type=style&index=0&id=0956b106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956b106",
  null
  
)

export default component.exports